import get from 'lodash/get'

const timeSlotColumns = t => [
	{
		accessor: 'id',
		show: false
	}, {
		accessor: 'timeSlot',
		Header: t('common.fields.code'),
		show: false
	}, {
		accessor: 'description',
		Header: t('common.fields.code')
	}, {
		Header: t('common.dates.week_day'),
		accessor: 'day',
		Cell: ({ original }) => {
			const cellVal = get(original, 'day', '')
			return cellVal ? t(`common.dates.${cellVal.toLowerCase()}`) : null
		}
	}, {
		Header: t('common.fields.from_time'),
		accessor: 'openingTime.from',
		Cell: ({ original }) => get(original, 'openingTime.from', '').slice(0, 5)
	}, {
		Header: t('common.fields.to_time'),
		accessor: 'openingTime.to',
		Cell: ({ original }) => get(original, 'openingTime.to', '').slice(0, 5)
	}, {
		Header: t('common.fields.lunch_break_start'),
		accessor: 'lunchBreak.from',
		Cell: ({ original }) => (get(original, 'lunchBreak.from', '') || '').slice(0, 5)
	}, {
		Header: t('common.fields.lunch_break_end'),
		accessor: 'lunchBreak.to',
		Cell: ({ original }) => (get(original, 'lunchBreak.to', '') || '').slice(0, 5)
	}
]

export default timeSlotColumns
